import { Logger } from '@farmersdog/logger';

import type { Feature, FeatureReturns } from './features';

export function parseConfig<F extends Feature>(
  feature: F,
  configJSON: string
): FeatureReturns[F]['config'] | undefined {
  try {
    return JSON.parse(configJSON) as FeatureReturns[F]['config'];
  } catch (e) {
    const logger = new Logger('tosa:frontend:experiments:parseConfig');
    logger.error('Failed to parse Split config JSON', {
      feature,
      configJSON,
      error: e,
    });

    return undefined;
  }
}
